export default {
  Button: {
    Login         : 'Σύνδεση',
    Logout        : 'Έξοδος',
    Register      : 'Εγγραφή',
    ForgotPassword: 'Ξέχασα τον κωδικό πρόσβασης',
    ResetPassword : 'Επαναφορά Κωδικού',
    NoAccount     : 'Δεν έχετε λογαριασμό; Κάντε Εγγραφή',
    WithAccount   : 'Έχετε ήδη λογαριασμό; Κάντε Είσοδο'
  },

  Login: {
    Success: 'Έχετε συνδεθεί με επιτυχία.'
  },

  Logout: {
    Success: 'Έχετε αποσυνδεθεί με επιτυχία.'
  },

  AccountDialog: {
    MemberSince: 'Μέλος από'
  },

  LoginDialog: {
    Title   : 'Δημιούργησε Λογαριασμό ή Συνδέσου',
    Subtitle: '',
    Social  : {
      Title   : 'Συνδέσου παρακάτω ή δημιούργησε έναν νέο λογαριασμό',
      Google  : 'Συνέχεια με GOOGLE',
      Facebook: 'Συνέχεια με FACEBOOK'
    },
    Account: {
      Title: 'Σύνδεση μέσω email',
      Field: {
        Email: {
          Label      : 'Email',
          Hint       : '',
          Placeholder: 'Email'
        },
        Password: {
          Label      : 'Κωδικός',
          Hint       : '',
          Placeholder: 'Κωδικός'
        }
      }
    }
  },

  ResetPasswordDialog: {
    Title   : 'Υπενθύμιση Κωδικού',
    Subtitle: 'Θα σας σταλεί email με νέο κωδικό πρόσβασης.',
    Field   : {
      Email: {
        Label      : 'Email',
        Hint       : '',
        Placeholder: 'Email'
      }
    }
  },

  RegisterDialog: {
    Title   : 'Κάνε Εγγραφή',
    Subtitle: 'Συμπλήρωσε τα παρακάτω πεδία & δημιούργησε τον λογαριασμό σου.',
    Field   : {
      Firstname: {
        Label      : 'Όνομα',
        Hint       : '',
        Placeholder: 'Όνομα'
      },
      Lastname: {
        Label      : 'Επώνυμο',
        Hint       : '',
        Placeholder: 'Επώνυμο'
      },
      Email: {
        Label      : 'Διεύθυνση Email',
        Hint       : '',
        Placeholder: 'Διεύθυνση Email'
      },
      Phone: {
        Label      : 'Κινητό Τηλέφωνο',
        Hint       : '',
        Placeholder: 'Κινητό Τηλέφωνο'
      },
      Password: {
        Label      : 'Κωδικός',
        Hint       : '',
        Placeholder: 'Κωδικός'
      },
      PasswordConfirm: {
        Label      : 'Επιβεβαίωση Κωδικού',
        Hint       : '',
        Placeholder: 'Επιβεβαίωση Κωδικού'
      },
      TermsCondition: {
        Label: 'Συμφωνώ με τους',
        And  : 'και την',
        Links: [
          {
            Title: 'Όρους Χρήσης',
            Url  : '/el/page/policies/terms'
          },
          {
            Title: 'Πολιτική Απορρήτου',
            Url  : '/el/page/policies/privacy'
          }
        ]
      },
      MarketingConsent: {
        Label: 'Επιθυμώ να λαμβάνω ενημερώσεις για νέα προϊόντα, προσφορές και εκδηλώσεις.'
      }
    }
  }
}
